export const STEPS = [
  { id: "bvn", label: "BVN Verification & Credit Check" },
  { id: "eligibility", label: "Mortgage Eligibility" },
  { id: "application", label: "Mortgage Application" },
];
